import {assertNever} from "@cm/utils"
import type {HalImageAddressMode} from "@cm/hal"
import {resolveTextureAddressMode} from "#webgl2/webgl2-shader-utils"

export function getHalAddressMode(addressMode: HalImageAddressMode): number {
    switch (addressMode) {
        case "clamp":
            return resolveTextureAddressMode("CLAMP_TO_EDGE")
        case "wrap":
            return resolveTextureAddressMode("REPEAT")
        case "wrap-mirrored":
            return resolveTextureAddressMode("MIRRORED_REPEAT")
        case "border":
            return resolveTextureAddressMode("BORDER")
        default:
            assertNever(addressMode)
    }
}
